export default __webpack_public_path__ + "static/heroBanner-8f6cddc842d95e430c4c11dc7b5f838a.png";